import dotProp from 'dot-prop-immutable'
import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import DraggableProduct from '../DraggableProduct'
import PreviewProduct from '../PreviewProduct'
import ResizableProduct from '../ResizableProduct'

const CanvasForFrames = ({ pictures = [], allowToResize = false, selectedIndex, aspect, crop, dim }) => {

  const wscale = dim && crop? dim.width/crop.cw:0
  const hscale = dim && crop? dim.height/crop.ch:0

  const resizePicture = (picture) => {
      const pic = {...picture};
      pic.width = pic.width*wscale
      pic.height = pic.height*hscale
      pic.tmpWidth = pic.tmpWidth*wscale
      pic.tmpHeight = pic.tmpHeight*hscale
      pic.position = pic.position? {
        x: pic.position.x*wscale,
        y: pic.position.y*hscale
      }: pic.position
      return pic
  }

  return (
  <Fragment>
    {pictures.map(resizePicture).map((picture, i) => (
      <DraggableProduct aspect={aspect} key={i} index={i} position={picture.position} height={picture.height} width={picture.width}>
        <PreviewProduct index={i} {...picture} />


        {allowToResize &&
          selectedIndex === i && <ResizableProduct aspect={aspect} index={i} width={picture.tmpWidth} height={picture.tmpHeight} />}
      </DraggableProduct>
    ))}
  </Fragment>
  )
}

CanvasForFrames.propTypes = {
  pictures: PropTypes.arrayOf(
    PropTypes.shape({
      position: PropTypes.shape({
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired,
      }).isRequired,
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
      tmpWidth: PropTypes.number.isRequired,
      tmpHeight: PropTypes.number.isRequired,
      selectedImage: PropTypes.string,
    })
  ),
  allowToResize: PropTypes.bool,
}

const mapStateToProps = state => ({
  pictures: dotProp.get(state, 'project.pictures', []),
  allowToResize: dotProp.get(state, 'project.allowToResize', false),
  selectedIndex: dotProp.get(state, 'project.selectedIndex', false),
  crop: dotProp.get(state, 'project.background.crop', { width: 100, height: 100 } ),
  dim: dotProp.get(state, 'project.dim', { width: 100, height: 100 }),
  aspect: dotProp.get(state, 'wallpapers.aspect', 1),
})

const mapDispatchToProps = () => ({})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CanvasForFrames)



// WEBPACK FOOTER //
// ./src/containers/DesignedCanvas/CanvasForFrames.js